<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<div class="mh-time-top">
				<b-row no-gutters>
					<b-col align-self="center" lg="3" md="12">
						<h2>Time Off</h2>
					</b-col>
					<b-col align-self="center" lg="9" md="12">
						<div class="mh-time-search">
							<div class="mh-time-search-inner">
								<i class="mh-icon-search"></i>
								<input type="text" placeholder="Search Here..." v-model="search">
							</div>
							<div class="mh-time-status">
								<b-select class="btn-select" v-model="status" :options="leaveStatuses" text-field="name" value-field="value" />
							</div>
							<div class="mh-add-entry"><button class="btn btn-default" @click="showAddTimeOffForm"><i class="mh-icon-plus"></i>Add Time Off</button></div>
						</div>
					</b-col>
				</b-row>
			</div>

			<div v-show="!showForm && !isViewing" class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<b-row class="m-0">
						<b-col v-if="records.length != 0" cols="12" :class="`p-0 d-lg-block${isViewing ? ' d-none' : ''}`">
							<div class="table-reponsive mh-entries-list">
								<div class="dataTables_wrapper no-footer">
									<data-table v-bind="bindings"
												:showPerPage="false"
												:showEntriesInfo="false"
												:showSearchFilter="false"
												:showPagination="true"
												:showDownloadButton="false"
												:text="{ emptyTableText: '' }"
												sortingMode="single"
												tableClass="table table-curved dataTable"
												ref="dataTable" />
								</div>
							</div>
						</b-col>
						<b-col v-else cols="12" class="no-time-entries-container text-center p-0 pt-4">
							<img src="../assets/images/no-time-off.png" class="mb-5" />
							<div class="title mb-2">Track Time Off</div>
							<div class="text mb-4">Enter sick, vacation, or holidays time</div>
							<b-button class="btn-default p-3" @click="showAddTimeOffForm"><i class="mh-icon-plus mr-2"></i>Add Time Off</b-button>
						</b-col>
					</b-row>
				</div>
			</div>

			<b-card v-if="isViewing" no-body class="mh-card mh-card-page">
				<b-card-header class="mh-bg-primary d-flex align-items-center">
					<h3 class="card-title">Time Off</h3>
					<div class="col-auto ml-auto p-0">
						<button type="button" class="btn btn-link mh-btn-icon" @click="cancelView"><i class="mh-icon-close"></i></button>
					</div>
				</b-card-header>
				<b-card-body class="mh-off-middle">
					<b-row class="m-0">
						<b-col cols="12">
							<div class="mh-profile-label">
								<div class="mh-img-wrap">
									<ProfileImage :imageUrl="profilePicture" />
									<span class="mh-user-online"></span>
								</div>
								<span class="mh-title">{{profile.email}}</span>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="mh-edit-item">
								<span>
									<i class="mh-icon-calendar"></i>
									{{moment(selectedRecord.from, 'DD-MM-YYYY').format('MMM D,YYYY')}}
								</span>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="mh-edit-item">
								<span>
									<i class="mh-icon-watch2"></i>
									{{selectedRecord.duration}}
								</span>
							</div>
						</b-col>
						<b-col cols="12">
							<div class="mh-edit-item">
								<span>
									<i class="mh-icon-ticket"></i>
									{{selectedRecord.leavetype}}
								</span>
							</div>
						</b-col>
						<b-col v-if="selectedRecord.description != ''" cols="12">
							<div class="mh-edit-description">
								<div classs="mh-edit-description-p">{{selectedRecord.description}}</div>
							</div>
						</b-col>
					</b-row>
					<b-row class="mr-0 ml-0 mh-AddTimeOff-action-btn">
						<b-col cols="4">
							<div class="mh-time-off-time">
								<span v-html="selectedRecord.durationFormatted"></span>
								<small>This Request</small>
							</div>
						</b-col>
						<b-col cols="8" class="pr-0">
							<b-row>
								<b-col align-self="center" cols="5" class="p-0"><button class="btn btn-default btn-green btn-block" @click="editRow(selectedRecord)" :disabled="!selectedRecord.canEdit">Edit</button></b-col>
								<b-col align-self="center" cols="7" class="p-0 pl-2"><button class="btn btn-default btn-block" @click="cancelRecord(selectedRecord)">Cancel Entry</button></b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>

			<b-card no-body v-show="showForm" class="mh-card mh-card-page">
				<b-card-header class="mh-bg-primary d-flex align-items-center">
					<h3 class="card-title">{{isEditing ? "Update": "Add"}} Time Off</h3>
					<b-col cols="auto" class="ml-auto p-0">
						<button type="button" class="btn btn-link mh-btn-icon" @click="closeForm"><i class="mh-icon-close"></i></button>
					</b-col>
				</b-card-header>
				<b-card-body class="mh-off-middle pl-0 pr-0">
					<fieldset :disabled="isFormDisabled">
						<b-row class="m-0">
							<b-col lg="6" md="12">
								<div class="mh-profile-label">
									<div class="mh-img-wrap">
										<ProfileImage :imageUrl="profilePicture" />
										<span class="mh-user-online"></span>
									</div>
									<span class="mh-title">{{profile.email}}</span>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col md="12">
								<label class="mh-label required">Code</label>
								<b-select v-model="code" :options="leaveTypes" text-field="name" value-field="value" />
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col lg="6" md="12">
								<label class="mh-label required">From</label>
								<div class="mh-time-entry">
									<div class="mh-datepicker">
										<datepicker v-model="dateFrom" @input="calculateTotal" />
										<i class="mh-icon-calendar"></i>
									</div>
									<div class="pl-2 mh-timepicker">
										<TimeInput v-model="timeFrom" @input="calculateTotal" />
										<i class="mh-icon-watch"></i>
									</div>
								</div>
							</b-col>
							<b-col lg="6" md="12">
								<label class="mh-label required">To</label>
								<div class="mh-time-entry">
									<div class="mh-datepicker">
										<datepicker v-model="dateTo" @input="calculateTotal" :disabled-dates="{ to: moment(dateFrom).add(-1, 'days').toDate() }" />
										<i class="mh-icon-calendar"></i>
									</div>
									<div class="pl-2 mh-timepicker">
										<TimeInput v-model="timeTo" @input="calculateTotal" />
										<i class="mh-icon-watch"></i>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col cols="12">
								<label class="mh-label">Total</label>
								<b-input typeof="text" v-model="total" class="total" disabled />
							</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col md="12">
								<div class="form-group">
									<label class="mh-label">Notes</label>
									<textarea class="form-control" placeholder="Write Your Note Here..." v-model="notes"></textarea>
								</div>
							</b-col>
						</b-row>
					</fieldset>
					<b-row class="m-0 mh-action-nav">
						<b-col cols="6">
							<button class="btn btn-default btn-grey" @click="closeForm">Close</button>
						</b-col>
						<b-col cols="6">
							<button class="btn btn-default" @click="saveRecord" :disbled="isFormDisabled">Save</button>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import ProfileImage from "./partials/ProfileImage"
	import SortingIcon from "./partials/SortingIcon"
	import TableRowActions from "./partials/TableRowActions"
	import TimeInput from "./partials/controls/TimeInput"
	import { bus } from "./../main"
	import moment from "moment"

	export default {
		name: 'TimeOffContent',
		components: {
			ContentTitle,
			ProfileImage,
			SortingIcon,
			TableRowActions,
			TimeInput
		},
		data: function () {
			return {
				search: "",
				status: 0,
				viewing: false,
				editing: false,
				adding: false,
				selectedRecord: {},
				id: 0,
				code: null,
				dateFrom: new Date(),
				timeFrom: "",
				dateTo: new Date(),
				timeTo: "",
				total: "",
				notes: null
			}
		},
		mounted: function () {
			this.$store.dispatch("Leave/getLeave")

			bus.$off('editDetailsTableRowAction')
			bus.$on('editDetailsTableRowAction', obj => { this.editRow(obj) })
			bus.$off('deleteDetailsTableRowAction')
			bus.$on('deleteDetailsTableRowAction', obj => { this.deleteRow(obj) })
			bus.$off('viewDetailsTableRowAction')
			bus.$on('viewDetailsTableRowAction', obj => { this.viewRow(obj) })
		},
		watch: {
			search: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.$refs.dataTable != null) {
						this.$refs.dataTable.search = newValue
						this.$refs.dataTable.setSearch()
					}
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			leave: function () {
				return this.$store.state.Leave.leave
			},
			leaveStatuses: function () {
				var statuses = this.$store.state.Leave.leaveStatuses.slice()

				statuses.unshift({ name: "", value: 0 })

				return statuses
			},
			leaveTypes: function () {
				return this.$store.state.Leave.leaveTypes
			},
			records: function () {
				return this.leave
					.map(x => {
						return {
							id: x.id,
							name: x.name,
							from: x.from,
							to: x.to,
							time: `${moment(x.from, "DD-MM-YYYYHH:mm:ss").format("D MMM YYYY hh:mm A")} - ${moment(x.to, "DD-MM-YYYY HH:mm:ss").format("D MMM YYYY hh:mm A")}`,
							shortDuration: x.from === x.to ? "1D" : this.$store.getters["Helper/getShortDuration"](x.from, x.to, true),
							duration: x.from === x.to ? "1D 0H 0M" : this.$store.getters["Helper/getDuration"](x.from, x.to),
							durationFormatted: x.from === x.to ? "1D<i>D</i> 0<i>H</i> 0<i>M</i>" : this.$store.getters["Helper/getDurationFormatted"](x.from, x.to),
							leavetypeid: x.leavetypeid,
							leavetype: x.leavetype,
							approved: x.approved,
							description: x.description,
							status: x.status,
							icons: [
								{
									class: "mh-icon-edit",
									title: "Edit",
									emit: "editDetailsTableRowAction",
									disabled: x.status == "2"
								},
								{
									class: "trash-alt",
									title: "Delete",
									emit: "deleteDetailsTableRowAction",
									disabled: x.status == "2"
								},
								{
									class: "mh-icon-eye",
									title: "View",
									emit: "viewDetailsTableRowAction"
								}
							]
						}
					})
					.filter(x => {
						return (this.status == 0 || this.status == x.status)
							&& ((x.name + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.time + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.duration + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.leavetype + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.approved + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
								|| (x.description + "").toLowerCase().indexOf(this.search.toLowerCase()) > -1)
					})
			},
			columns: function () {
				var columns = [
					{ key: "name", title: "Name", searchable: true, sortable: true },
					{ key: "time", title: "Time In-Out", searchable: true, sortable: true },
					{ key: "shortDuration", title: "Duration", searchable: true, sortable: true },
					{ key: "leavetype", title: "Leave Type", searchable: true, sortable: true },
					{ key: "approved", title: "Approved", searchable: true, sortable: true },
					{ key: "", title: "", component: TableRowActions }
				]

				if (this.isViewing)
					columns = [
						{ key: "time", title: "Time In-Out", searchable: true, sortable: true },
						{ key: "leavetype", title: "Leave Type", searchable: true, sortable: true },
						{ key: "approved", title: "Approved", searchable: true, sortable: true }
					]

				return columns
			},
			bindings: function () {
				return {
					SortingIconComponent: SortingIcon,
					columns: this.columns,
					data: this.records
				}
			},
			isEditing: function () {
				return this.editing
			},
			isViewing: function () {
				return this.viewing
			},
			showForm: function () {
				return this.adding || this.editing
			},
			isFormDisabled: function () {
				return this.selectedRecord != null && this.selectedRecord.status != "2"
			},
			isCodeValid: function () {
				if (this.code == null) {
					this.$store.commit("Toasts/showError", { title: "Code", content: "Code is required" })

					return false
				}

				return true
			},
			isDateFromValid: function () {
				if (this.dateFrom == null) {
					this.$store.commit("Toasts/showError", { title: "From Date", content: "From Date is required" })

					return false
				}

				return true
			},
			isTimeFromValid: function () {
				if (this.timeFrom == "") {
					this.$store.commit("Toasts/showError", { title: "Time From", content: "Time From is required" })

					return false
				}

				return true
			},
			isDateToValid: function () {
				if (this.dateTo == null) {
					this.$store.commit("Toasts/showError", { title: "To Date", content: "To Date is required" })

					return false
				}

				return true
			},
			isTimeToValid: function () {
				if (this.timeTo == "") {
					this.$store.commit("Toasts/showError", { title: "Time To", content: "Time To is required" })

					return false
				}

				if (moment(this.dateFrom).format("YYYY-MM-DD") == moment(this.dateTo).format("YYYY-MM-DD")
					&& this.timeFrom == ""
					&& this.timeTo == "") {
					this.$store.commit("Toasts/showError", { title: "Time To", content: "Time To cannot be the same as Time From" })

					return false
				}

				var from = moment(`${moment(this.dateFrom).format("YYYY-MM-DD")} ${this.timeFrom}`, "YYYY-MM-DD HH:mm")
				var to = moment(`${moment(this.dateTo).format("YYYY-MM-DD")} ${this.timeTo}`, "YYYY-MM-DD HH:mm")

				if (to.isSameOrBefore(from)) {
					this.$store.commit("Toasts/showError", { title: "Time To", content: "Time To cannot be before Time From" })

					return false
				}

				return true
			},
			isNotesValid: function () {
				return true
			}
		},
		methods: {
			setSelectedRecord: function (id) {
				this.selectedRecord = this.records.filter(x => x.id == id)[0]

				this.selectedRecord.canEdit = this.selectedRecord.status == "2"
				this.selectedRecord.canDelete = this.selectedRecord.status == "2"
			},
			calculateTotal: function () {
				var from = moment(`${moment(this.dateFrom).format("YYYY-MM-DD")} ${this.timeFrom}`, "YYYY-MM-DD HH:mm")
				var to = moment(`${moment(this.dateTo).format("YYYY-MM-DD")} ${this.timeTo}`, "YYYY-MM-DD HH:mm")

				this.total = moment.duration(to.diff(from)).format("d[D] h[H] m[M]", { forceLength: true, trim: false })
			},
			editRow: function (obj) {
				this.viewing = false
				this.editing = true
				this.setSelectedRecord(obj.id)

				this.id = this.selectedRecord.id
				this.code = this.selectedRecord.leavetypeid

				var dateFrom = moment(this.selectedRecord.from, "DD-MM-YYYY HH:mm:ss")

				this.dateFrom = dateFrom.toDate()
				this.timeFrom = dateFrom.format("HH:mm")

				var dateTo = moment(this.selectedRecord.to, "DD-MM-YYYY HH:mm:ss")

				this.dateTo = dateTo.toDate()
				this.timeTo = dateTo.format("HH:mm")
				this.notes = this.selectedRecord.description

				this.calculateTotal()
			},
			cancelRecord: function (obj) {
				var parameters = {
					id: this.selectedRecord.id || this.id,
					userid: this.profile.userid,
					from: moment(this.dateFrom).set({ hour: this.timeFrom.split(":")[0], minute: this.timeFrom.split(":")[1] }).format("YYYY-MM-DD HH:mm:ss"),
					to: moment(this.dateTo).set({ hour: this.timeTo.split(":")[0], minute: this.timeTo.split(":")[1] }).format("YYYY-MM-DD HH:mm:ss"),
					savetime: true
				}

				var $this = this

				this.$store.commit("Confirmation/show", {
					text: `Do you want to cancel <b>${obj.name} (${moment(obj.from, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY hh:mm A")} - ${moment(obj.to, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY hh:mm A")})</b>?`,
					okCallback: function () {
						$this.cancelView()
						$this.$store.dispatch("Leave/cancel", parameters).then(function () {
							$this.$store.dispatch("Leave/getLeave")
						})
					},
					cancelCallback: null
				})
			},
			deleteRow: function (obj) {
				this.setSelectedRecord(obj.id)

				var parameters = {
					id: this.selectedRecord.id || this.id,
					userid: this.profile.userid
				}

				var $this = this

				this.$store.commit("Confirmation/show", {
					text: `Do you want to delete <b>${obj.name} (${moment(obj.from, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY hh:mm A")} - ${moment(obj.to, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY hh:mm A")})</b>?`,
					okCallback: function () {
						$this.cancelView()
						$this.$store.dispatch("Leave/delete", parameters).then(function () {
							$this.$store.dispatch("Leave/getLeave")
						})
					},
					cancelCallback: null
				})
			},
			viewRow: function (obj) {
				this.viewing = true
				this.setSelectedRecord(obj.id)
			},
			cancelView: function () {
				this.viewing = false

				this.clearForm()
			},
			showAddTimeOffForm: function () {
				this.viewing = false
				this.editing = false
				this.adding = true

				this.clearForm()
				this.calculateTotal()
			},
			closeForm: function () {
				this.viewing = false
				this.editing = false
				this.adding = false

				this.clearForm()
			},
			clearForm: function () {
				this.selectedRecord = null
				this.id = 0
				this.code = null
				this.dateFrom = new Date()
				this.timeFrom = ""
				this.dateTo = moment().add(1, 'days').toDate()
				this.timeTo = ""
				this.notes = null
			},
			isFormValid: function () {
				return this.isCodeValid
					&& this.isDateFromValid
					&& this.isTimeFromValid
					&& this.isDateToValid
					&& this.isTimeToValid
					&& this.isNotesValid
			},
			saveRecord: function () {
				if (!this.isFormValid()) {
					return
				}

				var parameters = {
					id: this.id,
					userid: this.profile.userid,
					name: this.notes,
					from: moment(this.dateFrom).set({ hour: this.timeFrom.split(":")[0], minute: this.timeFrom.split(":")[1] }).format("YYYY-MM-DD HH:mm:ss"),
					to: moment(this.dateTo).set({ hour: this.timeTo.split(":")[0], minute: this.timeTo.split(":")[1] }).format("YYYY-MM-DD HH:mm:ss"),
					leavetypeid: this.code,
					savetime: true
				}

				var $this = this

				this.$store.dispatch("Leave/save", parameters).then(function (id) {
					$this.id = id
					$this.$store.dispatch("Leave/getLeave")
				})
			}
		}
	};
</script>

<style scoped>
	.total {
		font-weight: bold !important;
		color: #000 !important;
		font-size: 18px !important;
	}
</style>